import React from "react";
import GPSMap from "./GPSMap";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
const GpsLocationModal = ({ selectedDevice, setSelectedDevice,lat,long }) => {
  return (
    <CModal
      alignment="center"
      id="map"
      visible={!!selectedDevice}
      size="lg"
      onClose={() => setSelectedDevice(null)}
    >
      <CModalHeader onClose={() => setSelectedDevice(false)}>
        <CModalTitle>Location for {selectedDevice.asset.name}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <GPSMap {...{ selectedDevice }} lat={lat} long={long} />
      </CModalBody>
    </CModal>
  );
};

export default GpsLocationModal;
